import { useCallback } from "react";
import { useMap } from "@vis.gl/react-google-maps";

/**
 * Returns a function that calls `map.fitBounds()` after the browser has
 * repainted, giving React time to mount/unmount sidebar panels so the
 * Google Maps container has its final dimensions.
 */
export function useDeferredFitBounds(mapId = "mainMap") {
  const map = useMap(mapId);

  const deferredFitBounds = useCallback(
    (bounds: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral | null | undefined) => {
      if (!bounds || !map) return;
      // setTimeout(0) lets React commit the state update (panel open/close),
      // then rAF waits for the browser to paint so the map container has resized.
      setTimeout(() => {
        requestAnimationFrame(() => {
          google.maps.event.trigger(map, "resize");
          map.fitBounds(bounds);
        });
      }, 0);
    },
    [map],
  );

  return deferredFitBounds;
}
